import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_REC012_Request,
  IAPI_REC012_Response,
} from "../../../type/apiType";
import {
  IAPI_REC014_Request,
  IAPI_REC014_Response,
} from "../../../type/apiType";

import {
  IAPI_REC019_Request,
  IAPI_REC019_Response,
} from "../../../type/apiType";

// 割増金一覧参照
const httpAPI_REC012 = async (
  param: IAPI_REC012_Request
): Promise<IAPI_REC012_Response> => {
  let res = await http.post(ApiUrl.API_REC012, {
    ...param,
  });

  return res.data;
};

// 割増金請求状態更新
const httpAPI_REC014 = async (
  param: IAPI_REC014_Request
): Promise<IAPI_REC014_Response> => {
  let res = await http.post(ApiUrl.API_REC014, {
    ...param,
  });

  return res.data;
};

// 割増金要処理一覧更新
const httpAPI_REC019 = async (
  param: IAPI_REC019_Request
): Promise<IAPI_REC019_Response> => {
  let res = await http.post(ApiUrl.API_REC019, {
    ...param,
  });

  return res.data;
};
export { httpAPI_REC012, httpAPI_REC014, httpAPI_REC019 };
